function LanguageData() {
  const languages = ["English", "Hindi", "Marathi"];
  return languages;
}

export default LanguageData;
